export const INSTANT = 'INSTANT';
export const HYBRID = 'HYBRID';
export const REQUEST = 'REQUEST';
export const CALL = 'CALL';
export const NONE = 'NONE';
export const CONCIERGE = 'CONCIERGE';
